import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { checkTokenValidation } from "../auth/tokenReq";
import {
  AllTransactionType,
  MonthlyPaymentType,
  PaymentType,
} from "../../types/paymentTypes";

export const getAllTransactionReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": paymentReq->getPaymentsByMonthReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getAllTransactionKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = {
      allTime: resData?.allTime || "0",
      thisMonth: resData?.thisMonth?.map((item: AllTransactionType) => ({
        month: item?.month || "",
        year: item?.year || "",
        totalAmount: item?.totalAmount || "0",
      })),
    };
    return {
      error: false,
      data: _data,
      message: _msg,
      errorMsg: "",
    };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getPaymentsByMonthReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": paymentReq->getPaymentsByMonthReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getPaymentsByMonthKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = resData?.map((item: MonthlyPaymentType) => ({
      month: item?.month || "",
      totalAmount: item?.totalAmount || "",
      transactionCount: item?.transactionCount || "",
      year: item?.year || "",
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getAllPaymentsReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": paymentReq->getAllPaymentsReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getAllPaymentsKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = resData?.map((item: PaymentType) => ({
      amount: item?.amount || "",
      receivedDate: item?.receivedDate || "",
      txnDetails: item?.txnDetails || "",
      company: {
        companyName: item?.company?.companyName || "",
      },
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
